import {
  Image as ExpoImage,
  ImageBackground as ExpoImageBackground,
  type ImageBackgroundProps,
  type ImageProps,
} from "expo-image";
import { cssInterop } from "nativewind";

cssInterop(ExpoImage, {
  className: {
    target: "style",
  },
});

cssInterop(ExpoImageBackground, {
  className: {
    target: "style",
  },
});

/**
 * A wrapper component for Expo Image with Nativewind `className` support via `cssInterop`.
 *
 * This component allows you to use Expo's optimized Image component while applying
 * utility classes using `nativewind`.
 *
 * @component
 * @example
 * ```tsx
 * import { Image } from '@/components/ui/Image';
 *
 * <Image
 *   source={{ uri: 'https://example.com/image.jpg' }}
 *   className="w-full h-32 rounded-lg"
 *   contentFit="cover"
 * />
 * ```
 */
export const Image = (props: ImageProps) => {
  return <ExpoImage cachePolicy="memory-disk" {...props} />;
};

/**
 * A wrapper component for Expo ImageBackground with Nativewind `className` support via `cssInterop`.
 *
 * This component allows you to use Expo's optimized ImageBackground component while applying
 * utility classes using `nativewind`.
 *
 * @component
 * @example
 * ```tsx
 * import { ImageBackground } from '@/components/ui/Image';
 *
 * <ImageBackground
 *   source={{ uri: 'https://example.com/image.jpg' }}
 *   className="w-full h-32 rounded-lg"
 * >
 *   <View className="w-full h-32 rounded-lg">
 *     <Text>Image Background</Text>
 *   </View>
 * </ImageBackground>
 * ```
 */
export const ImageBackground = (props: ImageBackgroundProps) => {
  return <ExpoImageBackground cachePolicy="memory-disk" {...props} />;
};
export type { ImageProps, ImageBackgroundProps };
